export default __webpack_public_path__ + "static/media/people-bw.d55b9ddd.jpg";